
import { useEffect, useState } from 'react';
import { format } from 'date-fns';
import {
  TextField,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Select,
  MenuItem,
  Typography,
  Paper,
  Grid,
  IconButton,
  Box,
  useTheme,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import logo1 from '../../assets/logo/brix logo1.png';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import axios from 'axios';
import { BASEURL, AUTOFILL_STYLES ,IMAGEURL} from '../../constants/Common';
import { useLocation, useNavigate } from 'react-router-dom';
import { Invoice } from './Invoicehistory';
import { toast } from 'react-toastify';
import { ThemeProvider } from '@mui/material/styles';
import getTheme from '../../theme/theme';

interface InvoiceRow {
  description: string;
  quantity: number;
  unitPrice: number;
  tax: string;
  taxPercentage: number;
  amount: number;
}

const InvoiceTemplate: React.FC = () => {
  const location = useLocation();
  const theme = useTheme();
  const orgId = localStorage.getItem('orgid');
  //  const [orgId, setOrgId] = useState<string>('8'); // Example org_id
  const [invoices, setInvoices] = useState<Invoice[]>([]);
  const [error, setError] = useState<string | null>(null);

  const [rows, setRows] = useState<InvoiceRow[]>([
    { description: '', quantity: 1, unitPrice: 0, tax: 'HST', taxPercentage: 15, amount: 0 },
  ]);
  const invoice = location.state?.invoice; // Retrieve invoice data from state

  const date1 = invoice?.invoice_date
  // const formattedDate1 = date1 ? format(new Date(date1), 'MM/dd/yyyy') : null;
  const parsedDate = date1 ? new Date(date1) : null; // Convert string to Date
 console.log("invoice:",invoice);
 console.log("invoicelogo:",invoice?.logo);

  useEffect(() => {
    if (invoice?.invoice_rows) {
      const initialRows = invoice.invoice_rows.map((item: any) => ({
        description: item.description || '',
        quantity: item.quantity || 1,
        unitPrice: item.unit_price || 0,
        tax: item.tax || 'HST',
        taxPercentage: item.tax_percentage || 15,
        amount: item.amount || 0,
      }));
      setRows(initialRows);
    }
  }, [invoice]);

  const date34 = new Date('01/03/2025')

  const [businessName, setBusinessName] = useState(invoice?.business_name || '');
  const [businessAddress, setBusinessAddress] = useState(invoice?.business_address || '');
  const [businessCity, setBusinessCity] = useState(invoice?.business_city || '');
  const [businessPhone, setBusinessPhone] = useState(invoice?.business_phone || '');
  const [businessEmail, setBusinessEmail] = useState(invoice?.business_email || '');
  const [clientName, setClientName] = useState(invoice?.client_name || '');
  const [clientAddress, setClientAddress] = useState(invoice?.client_address || '');
  const [clientCity, setClientCity] = useState(invoice?.client_city || '');
  const [clientPhone, setClientPhone] = useState(invoice?.client_phone || '');
  const [clientEmail, setClientEmail] = useState(invoice?.client_email || '');
  const [invoiceNumber, setInvoiceNumber] = useState(invoice?.invoice_number || '2025-0001');
  const [paymentTerms, setPaymentTerms] = useState(invoice?.payment_terms || '');
  // const [invoiceDate, setInvoiceDate] = useState<Date | null>(parsedDate || null);
  const [invoiceDate, setInvoiceDate] = useState<Date | null>(parsedDate || new Date());
  const [hstRegistration, setHstRegistration] = useState(invoice?.hst_registration || '');
  const [taxIdentificationNumber, settaxIdentificationNumber] = useState(invoice?.tax_identification_no || '');
  const [businessRegistration, setBusinessRegistration] = useState(invoice?.business_registration || '');
  const [paymentOption, setPaymentOption] = useState(invoice?.payment_option || '');
  // const [logo, setLogo] = useState<string | null>(invoice?.logo || null);
  // const [logo, setLogo] = useState<string | undefined>(invoice?.logo || undefined);
  const [logo, setLogo] = useState<string | File | null>(invoice?.logo || null);
  const [logoPreview, setLogoPreview] = useState<string | undefined>(undefined);
  const [showNewTaxInput, setShowNewTaxInput] = useState<boolean>(false);
  const [newTax, setNewTax] = useState<string>("");
  const [customTaxTotals, setCustomTaxTotals] = useState<Record<string, number>>({});
  const [taxRates, setTaxRates] = useState<Record<string, number>>({
    HST: 15,
    GST: 5,
    "No Tax": 0,
  });
  const navigate = useNavigate();
  // const taxRates: Record<string, number> = {
  //   HST: 15,
  //   GST: 5,
  //   'No Tax': 0,
  // };




  const fetchInvoicesByOrgId = async (orgId: string): Promise<Invoice[]> => {
    try {
      const response = await axios.get(`${BASEURL}/fetch-invoices/`, {
        params: { orgId },
      });
      return response.data;
    } catch (error) {
      console.error('Failed to fetch invoices:', error);
      throw error;
    }
  };





  // Function to calculate the next invoice number
  // const calculateNextInvoiceNumber = (invoices: any[]) => {
  //   const numbers = invoices
  //     .map((invoice) => {
  //       const match = invoice.invoice_number.match(/\d+$/); // Extract numeric part from the end
  //       return match ? parseInt(match[0], 10) : null;
  //     })
  //     .filter((num): num is number => num !== null); // Type guard to filter out null values

  //   if (numbers.length > 0) {
  //     const maxNumber = Math.max(...numbers); // Find the max number
  //     return `${maxNumber + 1}`; // Increment and format
  //   }
  //   return '2025100'; // Default starting value
  // };





  // Function to calculate the next invoice number
  const calculateNextInvoiceNumber = (invoices: any[]) => {
    const numbers = invoices
      .map((invoice) => {
        const match = invoice.invoice_number.match(/2025-(\d{4})$/); // Extract the numeric part after '2025-'
        return match ? parseInt(match[1], 10) : null;
      })
      .filter((num): num is number => num !== null); // Filter out null values

    if (numbers.length > 0) {
      const maxNumber = Math.max(...numbers); // Find the max number
      const nextNumber = maxNumber + 1; // Increment the number
      return `2025-${String(nextNumber).padStart(4, '0')}`; // Format with leading zeros
    }

    return '2025-0001'; // Default starting value
  };


  // useEffect(() => {
  //     const fetchData = async () => {
  //         try {
  //             const data = await fetchInvoicesByOrgId(orgId);
  //             setInvoices(data);
  //         } catch (err) {
  //             setError('Failed to load invoices. Please try again.');
  //         }
  //     };

  //     fetchData();
  // }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (!orgId) {
          setError('Organization ID is missing.');
          return;
        }
        const data = await fetchInvoicesByOrgId(orgId);
        setInvoices(data);
      } catch (err) {
        setError('Failed to load invoices. Please try again.');
      }
    };

    fetchData();
  }, [orgId]); // Add orgId as a dependency


  // useEffect(() => {
  //   if (invoices.length > 0) {
  //     const nextInvoiceNumber = calculateNextInvoiceNumber(invoices);
  //     setInvoiceNumber(nextInvoiceNumber);
  //   }
  // }, [invoices]);


  useEffect(() => {
    // Only calculate the next invoice number if there is no existing invoice number
    if (!invoice?.invoice_number && invoices.length > 0) {
      const nextInvoiceNumber = calculateNextInvoiceNumber(invoices);
      setInvoiceNumber(nextInvoiceNumber);
    }
  }, [invoices, invoice?.invoice_number]);

  // console.log("invoices12:",invoices);
  const handleAddRow = () => {
    setRows([...rows, { description: '', quantity: 1, unitPrice: 0, tax: 'HST', taxPercentage: 15, amount: 0 }]);
  };

  const handleDeleteRow = (index: number) => {
    setRows(rows.filter((_, i) => i !== index));
  };


  const handleChange = (index: number, field: keyof InvoiceRow, value: any) => {
    const updatedRows = [...rows];

    // Dynamically handle value types for each field
    if (field === "description") {
      updatedRows[index][field] = value as string;
    } else if (field === "quantity" || field === "unitPrice" || field === "amount") {
      updatedRows[index][field] = parseFloat(value) as number;
    } else if (field === "tax") {
      updatedRows[index][field] = value as string;
    } else if (field === "taxPercentage") {
      updatedRows[index][field] = parseFloat(value) as number;
    }

    // Recalculate the amount based on quantity, unitPrice, and taxPercentage
    const row = updatedRows[index];
    const taxRate = (row.taxPercentage || 0) / 100; // Use user-entered tax percentage
    row.amount = row.quantity * row.unitPrice * (1 + taxRate);

    setRows(updatedRows);
  };


  const handleAddCustomTax = () => {
    if (newTax.trim() && !taxRates[newTax]) {
      setTaxRates((prev) => ({
        ...prev,
        [newTax]: 0, // Default percentage can be adjusted here
      }));
      setNewTax(""); // Clear the input field
      setShowNewTaxInput(false); // Hide the custom tax input
    }
  };



  // Calculate totals
  const totalWithoutTax = rows.reduce((total, row) => total + row.quantity * row.unitPrice, 0);
  const totalTax = rows.reduce(
    (total, row) => total + row.quantity * row.unitPrice * (row.taxPercentage / 100),
    0
  );
  const totalWithTax = totalWithoutTax + totalTax;


  const urlToFile = async (url: string): Promise<File> => {
    const response = await fetch(url);
    const blob = await response.blob();
  
    // Extract file name from URL by getting the last part after "/images/"
    const matches = url.match(/\/([^/]+)$/);
    const fileName = matches ? decodeURIComponent(matches[1]) : 'default.png'; // Decode and get file name after "/images/"
  
    return new File([blob], fileName, { type: blob.type });
  };


  // const handleLogoUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
  //   if (event.target.files && event.target.files[0]) {
  //     setLogo(event.target.files[0]);
  //   }
  // };

  // Handle file upload
  const handleLogoUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      setLogo(file); // Store the file
      
    }
  };



  const rowsData = rows.map((row, index) => ({
    sno: index + 1,
    description: row.description,
    quantity: row.quantity,
    unitPrice: row.unitPrice,
    tax: row.tax,
    taxPercentage: row.taxPercentage,
    amount: row.amount,
  }));


  const handlePreview = async() => {
    console.log("LOGO:",logo);
    let fileToPass: File | null = null;

    if (typeof logo === 'string' && logo.startsWith('/media/')) {
      // If it's a URL, fetch and convert it to a File object
      try {
        fileToPass = await urlToFile(`${BASEURL}/download_image?image_name=${encodeURIComponent(logo)}`);
      } catch (error) {
        console.error('Error converting URL to File:', error);
      }
    } else if (logo instanceof File) {
      // If it's already a File object, just use it
      fileToPass = logo;
    }
  
    console.log('Logo File:', fileToPass);
    navigate('/invoice/preview', {
      state: {
        orgId,
        logo: fileToPass,
        rows,
        businessName,
        businessAddress,
        businessCity,
        businessEmail,
        businessPhone,
        clientPhone,
        taxIdentificationNumber,
        clientName,
        clientAddress,
        clientCity,
        clientEmail,
        invoiceNumber,
        invoiceDate,
        paymentTerms,
        hstRegistration,
        businessRegistration,
        paymentOption,
        totalWithoutTax,
        totalTax,
        totalWithTax,
        rowsData,
        customTaxTotals,
      },
    });
  };


  const historyinvoice = () => {
    navigate('/invoicehistory')
  };

  // Ensure taxRates includes row.tax values
  useEffect(() => {
    const updatedTaxRates = { ...taxRates };
    rows.forEach((row) => {
      if (row.tax && !updatedTaxRates[row.tax]) {
        updatedTaxRates[row.tax] = 0; // Default tax percentage for new taxes
      }
    });
    setTaxRates(updatedTaxRates);
  }, [rows]); // Run when rows change







  // Update tax totals whenever rows change
  useEffect(() => {
    const updatedTaxTotals: Record<string, number> = {};

    Object.keys(taxRates).forEach((taxType) => {
      if (taxType !== "No Tax") {
        const taxTotal = rows
          .filter((row) => row.tax === taxType)
          .reduce((total, row) => {
            const taxRate = (row.taxPercentage || taxRates[taxType] || 0) / 100;
            return total + row.quantity * row.unitPrice * taxRate;
          }, 0);
        updatedTaxTotals[taxType] = taxTotal;
      }
    });

    setCustomTaxTotals(updatedTaxTotals);
  }, [rows, taxRates]);




  //  useEffect(() => {
  //     console.log("Fetched logo:", logo);

  //     if (logo instanceof File) {
  //       // If the logo is a File, create a preview URL
  //       const previewUrl = URL.createObjectURL(logo);
  //       setLogoPreview(previewUrl);

  //       return () => {
  //         URL.revokeObjectURL(previewUrl); // Cleanup the preview URL
  //       };
  //     } else if (typeof logo === "string") {
  //       // If the logo is a URL string, set it directly
  //       setLogoPreview(logo.startsWith("http") ? logo : `http://localhost:8000${logo}`);
  //     }
  //   }, [logo]);


  // useEffect(() => {
  //   if (logo instanceof File) {
  //     // If it's already a File, create preview
  //     const previewUrl = URL.createObjectURL(logo);
  //     setLogoPreview(previewUrl);
  
  //     return () => URL.revokeObjectURL(previewUrl);
  //   } else if (typeof logo === "string" && logo.trim() !== "") {
  //     // Ensure the backend URL is correct
  //     const logoUrl = logo.startsWith("http") ? logo : `${IMAGEURL}${logo}`;
  //      console.log("logoUrl:",logoUrl);
  //     fetch(logoUrl, { mode: "cors" }) // Ensure CORS mode
  //       .then((res) => {
  //         if (!res.ok) throw new Error(`HTTP error! Status: ${res.status}`);
  //         return res.blob();
  //       })
  //       .then((blob) => {
  //         const fileName = logo.split('/').pop() || 'logo.png';
  //         const file = new File([blob], fileName, { type: blob.type });
  //         setLogo(file); // Convert URL response to File
  //         setLogoPreview(URL.createObjectURL(file)); // Generate preview
  //       })
  //       .catch((err) => console.error("Error fetching logo as File:", err));
  //   }
  // }, [logo]);

  // useEffect(() => {
  //   if (invoice?.logo) {
  //     if (typeof invoice.logo === "string" && invoice.logo.trim() !== "") {
  //       // Ensure correct URL format
  //       const logoUrl = invoice.logo.startsWith("http") ? invoice.logo : `${IMAGEURL}${invoice.logo}`;
  
  //       fetch(logoUrl, { mode: "cors" }) // Ensure CORS handling
  //         .then((res) => {
  //           if (!res.ok) throw new Error(`HTTP error! Status: ${res.status}`);
  //           return res.blob();
  //         })
  //         .then((blob) => {
  //           const fileName = invoice.logo.split('/').pop() || "logo.png";
  //           const file = new File([blob], fileName, { type: blob.type });
  
  //           setLogo(file); // Convert URL response to File
  //           setLogoPreview(URL.createObjectURL(file)); // Generate preview
  //         })
  //         .catch((err) => console.error("Error fetching logo as File:", err));
  //     } else if (invoice.logo instanceof File) {
  //       // If it's already a File, generate preview
  //       setLogoPreview(URL.createObjectURL(invoice.logo));
  //     }
  //   }
  // }, [invoice?.logo]);
  

  return (
    <>
      <ThemeProvider theme={getTheme()}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            gap: 2,
            marginBottom: 2,
            mt: "-35px"
          }}
        >
          <Button variant="contained" onClick={handlePreview}>
            Preview
          </Button>
          <Button variant="contained" onClick={historyinvoice}>
            History
          </Button>
        </Box>

        <Paper sx={{ padding: 4 }}>
          <Typography variant="h4" align="center" gutterBottom>
            Invoice
          </Typography>
          <Grid container spacing={2} sx={{ marginBottom: 3 }}>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Business Name"
                value={businessName}
                onChange={(e) => setBusinessName(e.target.value)}
                sx={{
                  ...AUTOFILL_STYLES(theme),
                }}
              />
              <TextField
                fullWidth
                label="Business Address"
                value={businessAddress}
                onChange={(e) => setBusinessAddress(e.target.value)}
                sx={{ marginTop: 2 }}
                multiline
                rows={3}
              />
              <TextField
                fullWidth
                label="City, Provinces & Postal Code"
                value={businessCity}
                onChange={(e) => setBusinessCity(e.target.value)}
                sx={{ marginTop: 2 }}
                multiline
                rows={3}
              />
              <TextField
                fullWidth
                label="Business Phone"
                value={businessPhone}
                onChange={(e) => setBusinessPhone(e.target.value)}
                sx={{ marginTop: 2, ...AUTOFILL_STYLES(theme) }}
              />
              <TextField
                fullWidth
                label="Business Email"
                value={businessEmail}
                onChange={(e) => setBusinessEmail(e.target.value)}
                sx={{ marginTop: 2, ...AUTOFILL_STYLES(theme) }}
              />
              <TextField
                fullWidth
                label="HST Registration"
                value={hstRegistration}
                onChange={(e) => setHstRegistration(e.target.value)}
                sx={{ marginTop: 2, ...AUTOFILL_STYLES(theme) }}
              />
              <TextField
                fullWidth
                label="Business Registration"
                value={businessRegistration}
                onChange={(e) => setBusinessRegistration(e.target.value)}
                sx={{ marginTop: 2, ...AUTOFILL_STYLES(theme) }}
              />
              <TextField
                fullWidth
                label="Tax Identification Number"
                value={taxIdentificationNumber}
                onChange={(e) => settaxIdentificationNumber(e.target.value)}
                sx={{ marginTop: 2, ...AUTOFILL_STYLES(theme) }}
              />
              <Grid container justifyContent="center" sx={{ marginBottom: 3 }}>
               {/*  {logoPreview ? (
                  <img
                    //src={URL.createObjectURL(logo)}
                    //src={logo instanceof File ? URL.createObjectURL(logo) : logo}

                    src={logoPreview}
                    alt="Logo"
                    style={{ marginTop: 15, marginLeft: "-120px", maxHeight: '100px', marginBottom: '10px' }}
                  />
                ) : (
                  <Box sx={{ marginTop: 3, ml: "-230px" }}>
                    <Typography>Upload Logo</Typography>
                  </Box>

                )}
                <Button
                  variant="contained"
                  component="label"
                  startIcon={<UploadFileIcon />}
                  sx={{ marginTop: 2 }}
                >
                  Upload
                  <input type="file" hidden onChange={handleLogoUpload} />
                </Button>
              </Grid> */}
           {logo ? (
      typeof logo === 'string' ? (
        <img
          src={`${BASEURL}/download_image?image_name=${encodeURIComponent(logo)}`}
          alt="Logo"
          style={{
            marginTop: 15,
            marginLeft: "-120px",
            maxHeight: '100px',
            marginBottom: '10px',
          }}
        />
      ) : (
        <img
          src={URL.createObjectURL(logo)} // Show the file object if it's a file
          alt="Logo"
          style={{
            marginTop: 15,
            marginLeft: "-120px",
            maxHeight: '100px',
            marginBottom: '10px',
          }}
        />
      )
    ) : (
      <Box sx={{ marginTop: 3, ml: "-230px" }}>
        <Typography>Upload Logo</Typography>
      </Box>
    )}

    <Button
      variant="contained"
      component="label"
      startIcon={<UploadFileIcon />}
      sx={{ marginTop: 2 }}
    >
      Upload
      <input type="file" hidden onChange={handleLogoUpload} />
    </Button>
</Grid>
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Client Name"
                value={clientName}
                onChange={(e) => setClientName(e.target.value)}
                sx={{ ...AUTOFILL_STYLES(theme) }}
              />
              <TextField
                fullWidth
                label="Client Address"
                value={clientAddress}
                onChange={(e) => setClientAddress(e.target.value)}
                multiline
                rows={3}
                sx={{ marginTop: 2 }}
              />
              <TextField
                fullWidth
                label="City, Provinces & Postal Code"
                value={clientCity}
                onChange={(e) => setClientCity(e.target.value)}
                multiline
                rows={3}
                sx={{ marginTop: 2 }}
              />
              <TextField
                fullWidth
                label="Client Phone"
                value={clientPhone}
                onChange={(e) => setClientPhone(e.target.value)}
                sx={{ marginTop: 2, ...AUTOFILL_STYLES(theme) }}
              />
              <TextField
                fullWidth
                label="Client Email"
                value={clientEmail}
                onChange={(e) => setClientEmail(e.target.value)}
                sx={{ marginTop: 2, ...AUTOFILL_STYLES(theme) }}
              />
              <TextField
                fullWidth
                label="Invoice Number"
                value={invoiceNumber}
                disabled
                sx={{
                  marginTop: 11,
                  input: { color: '#000' }, // Text color inside the box
                  label: { color: '#333' }, // Label color and style
                  '.Mui-disabled': {
                    backgroundColor: '#e0e0e0', // Light gray background for the disabled field
                    WebkitTextFillColor: '#000', // Override text color in some browsers
                    ...AUTOFILL_STYLES(theme)
                  },
                }}
              // onChange={(e) => setInvoiceNumber(e.target.value)}
              />
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  label="Invoice Date"
                  value={invoiceDate}
                  onChange={(date) => setInvoiceDate(date)}
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      sx: { marginTop: 2 },
                    },
                  }}
                />
              </LocalizationProvider>

              <TextField
                fullWidth
                label="Payment Option"
                value={paymentOption}
                onChange={(e) => setPaymentOption(e.target.value)}
                sx={{ marginTop: 2, ...AUTOFILL_STYLES(theme) }}
              />
            </Grid>
          </Grid>

          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>S.No</TableCell>
                  <TableCell>Description</TableCell>
                  <TableCell>Quantity</TableCell>
                  <TableCell>Unit Price</TableCell>
                  <TableCell>Tax</TableCell>
                  <TableCell>Tax percentage</TableCell>
                  <TableCell>Amount</TableCell>
                  <TableCell>Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row, index) => (
                  <TableRow key={index}>
                    <TableCell>{index + 1}</TableCell>
                    <TableCell>
                      <TextField
                        value={row.description}
                        onChange={(e) => handleChange(index, 'description', e.target.value)}
                        fullWidth
                      />
                    </TableCell>
                    <TableCell>
                      <TextField
                        type="number"
                        value={row.quantity}
                        onChange={(e) => handleChange(index, 'quantity', parseFloat(e.target.value))}
                        fullWidth
                      />
                    </TableCell>
                    <TableCell>
                      <TextField
                        type="number"
                        value={row.unitPrice}
                        onChange={(e) => handleChange(index, 'unitPrice', parseFloat(e.target.value))}
                        fullWidth
                      />
                    </TableCell>
                    <TableCell>
                      <Select
                        value={row.tax || ""}
                        onChange={(e) => {
                          const selectedTax = e.target.value;
                          handleChange(index, "tax", selectedTax);
                          if (selectedTax === "Other") {
                            setShowNewTaxInput(true);
                          }
                        }}
                        fullWidth
                      >
                        {Object.keys(taxRates)
                          .filter((tax) => tax !== "Other") // Prevent duplicate "Other"
                          .map((tax) => (

                            <MenuItem key={tax} value={tax}>
                              {tax}
                            </MenuItem>
                          ))}
                        <MenuItem value="Other">Other</MenuItem>
                      </Select>
                      {row.tax === "Other" && showNewTaxInput && (
                        <div>
                          <TextField
                            label="Enter Custom Tax"
                            type="text"
                            value={newTax}
                            onChange={(e) => setNewTax(e.target.value)}
                            fullWidth
                          />
                          <Button
                            variant="contained"
                            onClick={handleAddCustomTax}
                            sx={{ marginTop: 1 }}
                          >
                            Save
                          </Button>
                        </div>
                      )}
                    </TableCell>
                    <TableCell>
                      <TextField
                        type="number"
                        value={row.taxPercentage}
                        onChange={(e) => handleChange(index, 'taxPercentage', parseFloat(e.target.value))}
                        fullWidth
                      />
                    </TableCell>
                    <TableCell>{row.amount.toFixed(2)}</TableCell>
                    <TableCell>
                      <IconButton color="error" onClick={() => handleDeleteRow(index)}>
                        <DeleteIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>

            {/* Total Row */}
            {/* <Table sx={{ marginTop: 2 }}>
        <TableBody>
          </Table> */}
          </TableContainer>

          {/* Total Row */}
          <TableContainer sx={{ marginTop: 2 }}>
            <Table>
              <TableBody>
                <TableRow>
                  <TableCell align="left" >
                    <Button variant="contained" onClick={handleAddRow}>
                      Add Row
                    </Button>
                  </TableCell>
                  <TableCell colSpan={32}></TableCell> {/* Empty cells to maintain alignment */}
                </TableRow>
                <TableRow>
                  <TableCell colSpan={30} align="right">Total without tax</TableCell>
                  <TableCell>{totalWithoutTax.toFixed(2)}</TableCell>
                  <TableCell></TableCell>
                </TableRow>
                {/* <TableRow>
                <TableCell colSpan={5} align="right">HST</TableCell>
                <TableCell>{totalTax.toFixed(2)}</TableCell>
                <TableCell></TableCell>
              </TableRow> */}
                {Object.keys(taxRates)
                  .filter((taxType) => taxType !== "No Tax") // Exclude "No Tax"
                  .map((taxType) => {
                    const taxTotal = rows
                      .filter((row) => row.tax === taxType)
                      .reduce((total, row) => {
                        const taxRate = (row.taxPercentage || 0) / 100;
                        return total + row.quantity * row.unitPrice * taxRate;
                      }, 0);
                    return (
                      <TableRow key={taxType}>
                        <TableCell colSpan={30} align="right">
                          {taxType} Tax
                        </TableCell>
                        <TableCell>{taxTotal.toFixed(2)}</TableCell>
                        <TableCell></TableCell>
                      </TableRow>
                    );
                  })}

                <TableRow>
                  <TableCell colSpan={30} align="right">Total with tax</TableCell>
                  <TableCell>{totalWithTax.toFixed(2)}</TableCell>
                  <TableCell></TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>

          {/* <Button variant="contained" onClick={handleAddRow} sx={{ marginTop: 2 }}>
          Add Row
        </Button> */}
          <Grid container spacing={2} alignItems="center" sx={{ marginTop: 2 }}>
            {/* Payment Term TextField */}

            <Grid item xs={4}>
              <TextField
                fullWidth
                label="Payment Terms"
                value={paymentTerms}
                onChange={(e) => setPaymentTerms(e.target.value)}
              />
            </Grid>

            {/* Add Row Button */}

          </Grid>
        </Paper>
      </ThemeProvider>
    </>
  );
};

export default InvoiceTemplate;
